import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as filiadoApi from '../api/filiados'

const Filiado = () => {

  const columns = [
    {
      title: "Nome",
      field: "name",
      sorting: true,

    },
  ];

  // const options = {
  //   filtering: true,
  //   actionsColumnIndex: -1,
  //   paging: false
  // }

  return (
    <React.Fragment>
      <Header title={"Solicitações dos Afiliados"} subtitle={"Lista de solicitações dos filiados, nesta aparecem apenas filiados pendentes"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            url={'filiados-solicitacoes'}
            columns={columns}
            fetchFunction={filiadoApi.fetchFiliadosPendentes}
            removeFunction={filiadoApi.removeItem}
            statusFunction={filiadoApi.statusItem}
            enableSearch
            enableDatas
            disableAdd
          />
        </BigCard>
      </Container>
    </React.Fragment>
  )
}

export default Filiado
